/**
 * «Ahora» inyectable: los días que faltan, el avance del viaje y las novedades dependen de la hora.
 * En la app es la hora real; en las pruebas, una fija.
 */
import { createContext, use, useState, type ReactNode } from "react";

const Contexto = createContext<() => Date>(() => new Date());

export function ProveedorReloj({ ahora, children }: { readonly ahora: () => Date; readonly children: ReactNode }) {
  return <Contexto value={ahora}>{children}</Contexto>;
}

/** Hora fijada al montar el componente: estable entre renders, se renueva al volver a la página. */
export function useAhora(): Date {
  const reloj = use(Contexto);
  const [ahora] = useState(reloj);
  return ahora;
}
